export const ENVIRONMENT = { DEVELOP: "develop", PRODUCTION: "production" };

export const DEPLOYED_ENVIRONMENT = ENVIRONMENT.PRODUCTION;
